<template>
	<modal :exibir="exibirModal" :titulo="tituloModal" :max-width="1250" class="modal-confirmacao" @close="fecharModal">
		<template #body>
			<v-row class="pa-4 row-css">
				<v-col>
					<label-personalizado nome-campo="Órgão" :obrigatorioPorPadrao="true"></label-personalizado>
					<v-autocomplete
						id="combo-autocomplete-orgao"
						v-model="dataObject.orgao.data"
						name="orgao"
						dense
						:items="dataObject.orgao.items"
						placeholder="Todos"
						class="pt-0"
						:debounce-search="250"
						item-value="id"
						item-text="nome"
						return-object
					></v-autocomplete>
				</v-col>
				<v-col>
					<label-personalizado nome-campo="Exercício" :obrigatorioPorPadrao="true"></label-personalizado>
					<v-autocomplete
						id="combo-autocomplete-exercicio"
						v-model="dataObject.exercicio.data"
						name="exercicio"
						dense
						:items="dataObject.exercicio.items"
						placeholder="Todos"
						class="pt-0"
						:debounce-search="250"
						item-value="id"
						item-text="nome"
						return-object
					></v-autocomplete>
				</v-col>
				<v-col>
					<label-personalizado nome-campo="Elemento/Subelemento"></label-personalizado>
					<v-autocomplete
						id="combo-autocomplete-elemento-subelemento"
						v-model="dataObject.classificacoesDespesas.data"
						name="elemento-subelemento"
						dense
						clearable
						:items="dataObject.classificacoesDespesas.items"
						placeholder="Todos"
						class="pt-0"
						:debounce-search="250"
						item-value="id"
						item-text="nome"
						return-object
					></v-autocomplete>
				</v-col>
				<botao-primario
					v-az-auth="permissoes.dotacaoOrcamentariaOrgaosVisualizar"
					nome-botao="FILTRAR"
					@click="buscarDotacoesOrcamentariasSetup"
				></botao-primario>
			</v-row>
			<v-row dense class="px-4" v-az-auth="permissoes.pedidoUtizacaoDotacaoOrcamentariaVisualizar">
				<v-col>
					<selecao-dotacao-orcamentaria-listagem
						v-model="dotacoesOrcamentariasSelecionadas"
						:itens="dotacoesOrcamentarias"
						:paginacao="paginacao"
						:total-itens="totalItens"
						:total-paginas="totalPaginas"
						@paginar="paginarListagem"
						@resetar-page="resetarPage"
					></selecao-dotacao-orcamentaria-listagem>
				</v-col>
			</v-row>
			<v-divider></v-divider>
			<v-row dense class="mt-2">
				<v-col align="right">
					<botao-primario
						v-az-auth="permissoes.pedidoUtizacaoDotacaoOrcamentariaCriar"
						nome-botao="SALVAR"
						class="botao-tamanho-arp mr-2"
						@click="adicionarDotacoes"
					></botao-primario>
				</v-col>
			</v-row>
		</template>
	</modal>
</template>
<script>
import { actionTypes } from '@/core/constants'
import Modal from '@/views/components/Modal.vue'
// eslint-disable-next-line vue/max-len
import SelecaoDotacaoOrcamentariaListagem from '@/views/pages/pedido/acessar/itens/listagem-dotacao-orcamentaria/incluir-dotacao-orcamentaria/listagem/SelecaoDotacaoOrcamentariaListagem.vue'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import validacaoPedido from '@/views/mixins/validacaoPedido'
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	name: 'modal-incluir-dotacao-orcamentaria',
	components: { PaginacaoTabela, LabelPersonalizado, BotaoPrimario, Modal, SelecaoDotacaoOrcamentariaListagem },
	mixins: [validacaoPedido],
	inject: ['idPedido'],
	props: {
		tituloModal: {
			type: String,
			default: '',
		},
		exibirModal: {
			type: Boolean,
			required: true,
		},
	},
	emits: ['fechar-modal', 'buscar-dotacoes'],
	data() {
		return {
			paginacao: PaginacaoListagem(['seq'], 25),
			totalPaginas: 1,
			totalItens: 0,
			dotacoesOrcamentariasSelecionadas: [],
			dataObject: {
				orgao: {
					data: {},
					items: [],
				},
				exercicio: {
					data: {},
					items: [],
				},
				classificacoesDespesas: {
					data: {},
					items: [],
				},
			},
			dotacoesOrcamentarias: [],
		}
	},
	async mounted() {
		await this.buscarClassificacoesDespesas()
		await this.buscarExercicios()
		await this.buscarOrgaos()
	},
	methods: {
		async adicionarDotacoes() {
			if (this.dotacoesOrcamentariasSelecionadas.length === 0) {
				throw new Error('Nenhuma dotação selecionada!')
			}

			try {
				const itens = this.dotacoesOrcamentariasSelecionadas.map((value) => ({ idExterno: value.id }))

				await this.$store.dispatch(actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.CRIAR_DOTACAO, {
					idDotacao: this.idPedido,
					itens,
				})

				this.fecharModal()
				this.dotacoesOrcamentariasSelecionadas = []
				this.mostrarNotificacaoSucesso('Dotações adicionadas com sucesso.')
				this.$emit('buscar-dotacoes')
			} catch (Err) {
				throw new Error(Err)
			}
		},
		async buscarDotacoesOrcamentariasSetup() {
			const filtros = this.getFiltrosBuscarDotacoesOrcamentariasSetup()

			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.SETUP.BUSCAR_LISTAGEM_PAGINADA,
				{ idPedido: this.idPedido, filtros: filtros, paginacao: this.paginacao },
			)

			this.dotacoesOrcamentarias = itens
			this.totalPaginas = totalPages
			this.totalItens = totalElements
		},
		async buscarOrgaos() {
			const { itens } = await this.$store.dispatch(
				actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.SETUP.BUSCAR_LISTAGEM_ORGAOS,
				Number(this.idPedido),
			)
			this.adicionarOrgaosNoFiltro(itens)
		},
		async buscarExercicios() {
			const { itens } = await this.$store.dispatch(
				actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.SETUP.BUSCAR_LISTAGEM_EXERCICIOS,
			)
			this.adicionarExerciciosNoFiltro(itens)
		},
		async buscarClassificacoesDespesas() {
			const { itens } = await this.$store.dispatch(
				actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.SETUP.BUSCAR_LISTAGEM_CLASSIFICACAO_DESPESAS,
				Number(this.idPedido),
			)
			this.adicionarClassificacoesDespesasNoFiltro(itens)
		},
		adicionarOrgaosNoFiltro(itens) {
			this.dataObject.orgao.items = itens.map((item) => {
				return { id: item.id, nome: item.nome }
			})
			this.dataObject.orgao.data = this.dataObject.orgao.items[0]
		},
		adicionarClassificacoesDespesasNoFiltro(itens) {
			this.dataObject.classificacoesDespesas.items = itens.map((item) => {
				return { id: item.id, nome: item.descricao }
			})
		},
		adicionarExerciciosNoFiltro(itens) {
			if (itens.length > 0) {
				this.dataObject.exercicio.items = itens.map((item) => {
					return { id: item.exercicio, nome: `${item.exercicio}` }
				})

				this.dataObject.exercicio.data = this.dataObject.exercicio.items[0]
			}
		},
		getFiltrosBuscarDotacoesOrcamentariasSetup() {
			const filtros = {
				idOrgao: this.dataObject.orgao.data?.id,
				exercicio: this.dataObject.exercicio.data?.nome,
				idElementoSubElemento: this.dataObject.classificacoesDespesas.data?.id,
			}

			return filtros
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		resetarPage() {
			this.paginacao.page = 1
		},
		async paginarListagem(paginacao) {
			this.paginacao = paginacao
			await this.buscarDotacoesOrcamentariasSetup()
		},
	},
}
</script>
<style lang="stylus" scoped>
.az-template-default
	.container
		background white
.row-css
	display flex
	align-items center
</style>
